import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { logout } from 'data/auth/action'
import { Menu, Segment } from 'semantic-ui-react'
import logo from 'img/logo.png'
import UserSubscription from '../../settings/components/subscription'
import '../../settings/style.css'

class SubErrorPage extends React.Component {
  constructor(props) {
    super(props)
    this.subRef = null
  }

  handleDeleteAccount = () => {
    if(this.subRef){
      this.subRef.onDeleteAccountClick()
    }
  }

  saveRef = r => this.subRef = r

  logout = () => {
    sessionStorage.clear()
    this.props.logout('/app/login')
  }

  render() {
    const {status,subscription} = this.props
    return (
      !status && !['expired'].includes(status) ?
      <Navigate to='/notfound'/>:
      <div className='ui container suberror_container'>
        <div className="LoginForm-title">Retirement Navigator</div>
        <a href="/"><img id='authLogo' src={logo} alt='logo'/></a>
        <div className="suberror_container_grid">
          <div className="suberror_container_grid--left">
            <Menu pointing vertical>
              <Menu.Item onClick={()=>{ window.location.href = 'https://bettermoneychoices.com/contact-us.html' }} name='contactus'>Contact us</Menu.Item>
              <Menu.Item onClick={this.logout} name='logout'>Log out</Menu.Item>
            </Menu>
          </div>
          <div className="suberror_container_grid--right">
            {subscription==='advisor'?
              <Segment>
                Subscription Expired Please contact Retirement Navigator  
              </Segment>
              :
              <Segment>
                Please contact your Advisor - Error ANP
              </Segment>
            }
          </div>
        </div>
      </div>
    )
  }
}

SubErrorPage.propTypes = { 
  status: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    status: state.auth.status,
    subscription : state.auth.subscription 
  }
}

export default connect(mapStateToProps, {logout})(SubErrorPage)
